import type { JSONContent } from '@tiptap/react';

import { renderToReactElement } from '@tiptap/static-renderer/pm/react';

import { extensions } from './extensions';

type Props = {
  content: JSONContent;
};

export const RichTextRenderer = ({ content }: Props) => {
  return (
    <div>
      {renderToReactElement({
        content: trimEmptyLines(content),
        extensions: extensions('renderer'),
        options: {
          unhandledNode: ({ children }) => <p>{children}</p>,
          unhandledMark: ({ children }) => <span>{children}</span>,
        },
      })}
    </div>
  );
};

const trimEmptyLines = (doc: JSONContent): JSONContent => {
  if (doc.content === undefined) return doc;

  const firstNonEmptyNode = doc.content.findIndex((node) => node.content !== undefined || node.type !== 'paragraph');
  const lastNonEmptyNode = doc.content.findLastIndex((node) => node.content !== undefined || node.type !== 'paragraph');

  if (firstNonEmptyNode === -1) return doc;

  return {
    ...doc,
    content: doc.content.slice(firstNonEmptyNode, lastNonEmptyNode + 1),
  };
};
